import { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa6";
import "../../styles/ScrollToTop.css";

export default function ScrollToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShow(window.scrollY > 350);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      className={`cs-scrolltop ${show ? "is-visible" : ""}`}
      onClick={goTop}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <FaChevronUp />
    </button>
  );
}
